import { FC } from 'react';

import './SparkSnapIcon.scss';

interface SparkSnapIconProps {
    imgUrl: string;
    title: string;
}

const SparkSnapIcon: FC<SparkSnapIconProps> = ({ imgUrl, title }) => {
    return (
        <div className="spark-snap-icon">
            <img src={imgUrl} alt={title} />
        </div>
    );
};

export default SparkSnapIcon;
